var path = '/components/directives/customfield/time.tpl.html';
var html = "<label for=\"{{name}}\" ng-if=\"field.definition.name\">\n    {{field.definition.name}} <span ng-if=\"field.definition.required\">*</span>\n</label>\n<p class=\"help-text\" ng-if=\"field.definition.help\">{{field.definition.help}}</p>\n<div class=\"datepicker\" moment-picker=\"field.ngModel\" format=\"Y-M-D HH:mm\" start-view=\"day\" locale=\"de\">\n    <input type=\"text\" name=\"{{name}}\" id=\"{{name}}\" ng-model=\"field.ngModel\">\n    <button type=\"button\" class=\"input-icon\"><i class=\"fal fa-clock\"></i></button>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/time.tpl.html
// module id = 2003
// module chunks = 1